import React, { useEffect, useState } from "react";
import { FaGlobe, FaInstagram, FaFacebook, FaEnvelope, FaDownload, FaTimes } from "react-icons/fa";
import { getBrandDisplayName } from '../utils/brandHelper';
import "../css/Footer.css";

const Footer = ({ isSidebarClosed }) => {
  const [showIOSInstructions, setShowIOSInstructions] = useState(false);
  const brandName = getBrandDisplayName();

  useEffect(() => {
    let deferredPrompt;
    const installBtn = document.getElementById('installAppBtn');
    if (!installBtn) return;

    // Detektáljuk az iOS eszközt
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isInStandaloneMode = window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;

    // Ha már telepítve van (standalone mode), rejtsük el a gombot
    if (isInStandaloneMode) {
      installBtn.style.display = 'none';
      return;
    }

    // iOS esetén mindig mutassuk a gombot
    if (isIOS) {
      installBtn.style.display = 'inline-flex';
    } else {
      installBtn.style.display = 'none';
    }

    const beforeInstallHandler = (e) => {
      e.preventDefault();
      deferredPrompt = e;
      installBtn.style.display = 'inline-flex';
    };

    const clickHandler = async () => {
      // iOS esetén megmutatjuk az utasításokat
      if (isIOS) {
        setShowIOSInstructions(true);
        return;
      }

      // Android/Desktop esetén használjuk a prompt API-t
      if (!deferredPrompt) return;
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      deferredPrompt = null;
      installBtn.style.display = 'none';
    };

    window.addEventListener('beforeinstallprompt', beforeInstallHandler);
    installBtn.addEventListener('click', clickHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', beforeInstallHandler);
      installBtn.removeEventListener('click', clickHandler);
    };
  }, []);

  return (
    <>
      <footer className={`footer${isSidebarClosed ? ' footer-closed-sidebar' : ''}`}>
        <div className="footer-content">
          <div className="footer-row footer-top">
            <span className="footer-title">{brandName} &copy; {new Date().getFullYear()}</span>
            <div className="footer-socials">
              <a href="https://premiumautomagyarorszag.hu/" className="footer-icon" aria-label="Weboldal" target="_blank" rel="noopener noreferrer"><FaGlobe /></a>
              <a href="https://www.instagram.com/premiumautomagyarorszag/" className="footer-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.facebook.com/premiumautomagyarorszag/" className="footer-icon" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
              <a href="mailto:info@interstrip.hu" className="footer-icon" aria-label="Email"><FaEnvelope /></a>
            </div>
            <button id="installAppBtn" className="footer-download-btn" title="Alkalmazás letöltése">
              <FaDownload style={{ marginRight: 6 }} /> Letöltés
            </button>
          </div>
          <div className="footer-row footer-links">
            <a href="#kapcsolat">Kapcsolat</a>
            <span className="footer-link-sep">|</span>
            <a href="#adatvedelem">Adatvédelmi tájékoztató</a>
            <span className="footer-link-sep">|</span>
            <a href="#utmutato">Felhasználói útmutató</a>
          </div>
        </div>
      </footer>

      {/* iOS telepítési utasítások modal */}
      {showIOSInstructions && (
        <div className="ios-install-modal-backdrop" onClick={() => setShowIOSInstructions(false)}>
          <div className="ios-install-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ios-install-header">
              <h3>Alkalmazás telepítése</h3>
              <button className="ios-install-close" onClick={() => setShowIOSInstructions(false)}>
                <FaTimes />
              </button>
            </div>
            <div className="ios-install-content">
              <p>Az alkalmazás telepítéséhez kövesd az alábbi lépéseket:</p>
              <ol className="ios-install-steps">
                <li>
                  <span className="step-number">1</span>
                  <span className="step-text">Nyomd meg az <strong>alul középen</strong> található <strong>megosztás</strong> gombot (négyzet egy nyíllal)</span>
                </li>
                <li>
                  <span className="step-number">2</span>
                  <span className="step-text">Görgess le és válaszd a <strong>"Hozzáadás a kezdőképernyőhöz"</strong> opciót</span>
                </li>
                <li>
                  <span className="step-number">3</span>
                  <span className="step-text">Nyomd meg a <strong>"Hozzáadás"</strong> gombot a jobb felső sarokban</span>
                </li>
              </ol>
              <p className="ios-install-note">
                <strong>Megjegyzés:</strong> Ez a funkció csak Safari böngészőben érhető el!
              </p>
            </div>
            <button className="ios-install-ok-btn" onClick={() => setShowIOSInstructions(false)}>
              Értem
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer; 